// React imports
import React, { Component } from "react";

// Package imports
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { Button, Image } from "react-bootstrap";

// Project imports
import NeedCard from "./components/optimization-card/NeedCard";
import OptimizationStore from "./store/OptimizationStore";
import ValidationErrorMessageShowModal from "../family-details-form/components/ValidationErrorMessageShowModal";
import FormContext from "context/FormContext";
import AddInsuredModalComponent from "./components/add-insured-modal/AddInsuredModalComponent";
import FamilyDetailsFormController from "modules/family-details-form/form/controller";
import AuthStore from "modules/login/store/AuthStore";
import addFamilyMemberFromUtils from "utils/addFamilyMember";
import addEmployeeMemberFromUtils from "utils/addEmployee";
import AddMemberCardModal from "modules/family-details-form/components/AddMemberCardModal";
import { fetchSelectedMembers, submitDataToTheServer, reInitializeFamilyMemberData } from "modules/family-details-form/form/utils";
import { fetchSelectedEmployees, submitEORFMDataToTheServer, reInitializeEmployeeData } from "modules/family-details-form/non-individual-journey-form/utils";
import FamilyMemberModalTypeEnum from "constants/familyMemberModalTypeEnum";
import StorageKeys from "constants/StorageKeys";
import { NextButton, Button as UiButton } from "../../components";
import FamilyMemberTypeEnum from "modules/family-details-form/FamilymemberTypeEnum";
import savePragatiNAInboundData from "utils/savePragatiNAInboundData";
import ValidationMsgForRecalculate from "./components/validation-msg-for-recalculate/ValidationMsgForRecalculate";
import * as images from "constants/Images";
import generateBasicDataStructure from "./utils/generateBasicDataStructure";
import { Container } from "react-bootstrap";
import toggleHighRiskTabFunction from "./utils/show-hide-high-risk/toggleHighRiskTabFunction";
import CustomerCommunicationDetailModal from "../solution/customerCommunicationDetail/CustomerCommunicationDetails"
import * as APITypes from "../../constants/API"

// CSS imports
import "./optimization.css";
import EmployeeDetailsFormController from "modules/family-details-form/non-individual-journey-form/controller";
import { EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, INDIVIDUAL, KEYMAN, MWP_ACT, PARTNERSHIP } from "constants/ CustomerType";
import AddEmployeeCardModal from "modules/family-details-form/components/non-individual-journey/AddEmployeeCardModal";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../constants/Constants";
import { ADD_NEED_CUSTOMIZATION } from "constants/UserClicksConstant";
import ToggleButton from "components/ui/toggle-button/ToggleButton";
import axios from "axios";

const Optimization = observer(
  class Optimization extends Component {
    constructor(props) {
      super(props);
      this.wrapperRef = React.createRef();
      this.handleClickOutside = this.handleClickOutside.bind(this);

      this.state = {
        familydetailsController: undefined,
        showFamilyMemberModal: false,
        showSelectAtleastOneNeed: false,
        showDropDownBtn: false,
        showHighRiskFlag: toJS(AuthStore.high_risk_flag),
        isPasaProduct: false
      };
    }

    static contextType = FormContext;

    showAddNeedModal = () => {
      //!for save user clicks
      AuthStore.saveUserClicks(ADD_NEED_CUSTOMIZATION)

      this.context.setIsAddNeedModalOpen(true);
      OptimizationStore.setFamilyMemberModalType(FamilyMemberModalTypeEnum.ADD_NEED);
    };

    async componentDidMount() {
      global.isLoading(false);
      await AuthStore.fetchAllData(getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID))
      await savePragatiNAInboundData(location)
      await OptimizationStore.showCampareProductTooltip()
      await OptimizationStore.showProductGraphTooltip()
      OptimizationStore.isLoading = false;
      let action = this.props.history.action;
      window.scrollTo(0, 0);
      // if (action != "POP") {
      //   OptimizationStore.emptyProductListData();
      //   OptimizationStore.updateResponseStructure();
      // }
      let pasaCampaignProduct = sessionStorage.getItem(StorageKeys.IS_PASA_PRODUCT) === "true" ? true : false
      this.setState({ isPasaProduct: pasaCampaignProduct })
      generateBasicDataStructure();
      let validJourneyTypes = [EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, PARTNERSHIP, KEYMAN];
      let formController = validJourneyTypes.includes(AuthStore.journeyTypeName) ? new EmployeeDetailsFormController() : new FamilyDetailsFormController();
      let journeyData = toJS(AuthStore.journeyData);
      let expenseList = toJS(AuthStore.expenseList);
      let lifeCoverList = toJS(AuthStore.lifeCoverList);
      formController.setDefaults(getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID), journeyData, expenseList, lifeCoverList);
      let highRiskFlag = toJS(AuthStore.high_risk_flag)

      this.setState({ familydetailsController: formController, showHighRiskFlag: highRiskFlag });
      document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }

    componentDidUpdate(){
      let pasaCampaignProduct = sessionStorage.getItem(StorageKeys.IS_PASA_PRODUCT) === "true" ? true : false
      if (this.state.isPasaProduct !== pasaCampaignProduct) {
        this.setState({ isPasaProduct: pasaCampaignProduct })
      }
    }

    handleClickOutside(event) {
      if (this?.wrapperRef && !this?.wrapperRef?.current?.contains(event.target)) {
        this.setState({ showDropDownBtn: false })
      }
    }

    onAddFamilyMember = (memberObjList) => {
      const selfDetail = memberObjList.find((obj) => obj.name === FamilyMemberTypeEnum.SELF);
      OptimizationStore.selfFamilyMemberDetail = selfDetail;

      const initialMemberList = memberObjList.map((eachMember) => eachMember.name)

      OptimizationStore.setFamilyMemberList(initialMemberList)
      this.setState({ showFamilyMemberModal: true });
    };

    addFamilyMember = async (formController, hideModal) => {
      let validJourneyTypes = [EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, PARTNERSHIP, KEYMAN];
      if (OptimizationStore.familyMemberModalType !== undefined || OptimizationStore.familyMemberModalType !== "") {
        if (validJourneyTypes.includes(AuthStore.journeyTypeName)) {
          await addEmployeeMemberFromUtils(formController, fetchSelectedEmployees, submitEORFMDataToTheServer, AuthStore, reInitializeEmployeeData, hideModal);
        } else {
          await addFamilyMemberFromUtils(formController, fetchSelectedMembers, submitDataToTheServer, AuthStore, reInitializeFamilyMemberData, hideModal);
        }
      }

      OptimizationStore.resetInsuredMemberDetails();
    };

    hideFamilymemberModal = () => {
      this.setState({ showFamilyMemberModal: false });
    };

    addInsuredOnHide = () => {
      OptimizationStore.setAddInsuredModalFunction(false);
    };

    showRiskTab = () => {
      this.setState({ showDropDownBtn: true })
    }

    hideRiskTab = async () => {

      let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
      const data = {
        journey_id,
        high_risk_flag: !this.state.showHighRiskFlag,
        flag: localStorage.getItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM) === false ? false : true
      };

      // OptimizationStore.togglehighRiskTabFunction(data)
      toggleHighRiskTabFunction(data)
      AuthStore.setHighRiskTab(!this.state.showHighRiskFlag)

      this.setState({ showDropDownBtn: false, showHighRiskFlag: !this.state.showHighRiskFlag })
    }

    setIsPasaProduct = async (e) => {
      let data = e.target.checked
      let isTotalSumAssured = ""

      if (data) {
        isTotalSumAssured = await OptimizationStore.calculateTotalSumAssuredOfAllProduct()
        if (!isTotalSumAssured) {
          AuthStore.setErrorModal("Sum Assured Is Not Match.")
          return false
      }}

      this.setState({ isPasaProduct: data })
      sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, data)
      let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
      const response = await axios.get(
        `${APITypes.UPDATE_PASA_OR_NON_PASA_JOURNEY}?journeyId=${journeyId}&is_pasa_product=${data}`
      )
      if (response.data?.message) {
        AuthStore.setErrorModal(response.data?.message)
        this.setState({ isPasaProduct: false })
        sessionStorage.setItem(StorageKeys.IS_PASA_PRODUCT, false)
      }
    }

    render() {
      let product_list_data = toJS(OptimizationStore.product_list_data);
      console.log("product_list_dataproduct_list_data", product_list_data)
      let validateCustomertype = [INDIVIDUAL, MWP_ACT]
      let isUlipUser = localStorage.getItem(StorageKeys.ULIP_TRAINING) === "1"
      let familyDataList = [];
      if (this.state.familydetailsController !== undefined && this.state.familydetailsController.has("members")) {
        familyDataList = this.state.familydetailsController.$("members").get();
      }
      
      const listOfDisabledNeeds = product_list_data.map(needObj => needObj.data[0].isDisabledNeed)
      OptimizationStore.setListOfTotalNeeds(listOfDisabledNeeds)
      
      let showSelectAtLeastOneNeedErrorMsg = toJS(OptimizationStore.showSelectAtLeastOneNeed)
      let showPasa = sessionStorage.getItem(StorageKeys.SHOW_PASA) === "true" ? true : false
      let maxUpsellValue = sessionStorage.getItem(StorageKeys.MAX_UPSELL_VALUE)


      return (
        <>
          <div className='container family-protection mb-4 mt-2 overflow-hidden'>
            {product_list_data.length == 0 && !global.isLoading() ? (
              <div className='text-center'>
                <div className='spinner-border text-primary' role='status'>
                  <span className='sr-only'>Loading...</span>
                </div>
              </div>
            ) : (
              <Container className="optimization-container">
                <div className='row position-r optimization-screen-top-index mb-md-5'>
                  <div className='col-12 col-md-12 position-fixed bg-light-gray'>
                    <div className="d-flex justify-content-between align-items-center customization-heading-container">
                      <p className='text-primary font-weight-medium mb-0 mr-1 font-size-18'>
                        Solution Customization
                        <span onClick={this.showAddNeedModal} className='cursor-pointer link-color font-size-14 font-size-lg-12 font-weight-light ml-1'>
                          [Add a Need]
                        </span>
                      </p>


                      {isUlipUser && <div ref={this.wrapperRef} className="ellipse-vertical-container">

                        <div className="ellipsis-vertical-btn-container">
                          <button className="ellipsis-vertical-btn" onClick={() => { this.showRiskTab() }}>
                            <Image
                              width="21"
                              src={images.ellipsisVertical}
                              alt="ellipsis-vertical"
                            />
                          </button>

                          {this.state.showDropDownBtn &&
                            <div id="ellipsis-vertical-id" className="ellipsis-vertical-content">
                              <div className="d-flex align-item-center justify-content-center">
                                <button onClick={() => { this.hideRiskTab() }}>
                                  <Image
                                    width="12"
                                    src={this.state.showHighRiskFlag ? images.eyeSlash : images.eye}
                                    className="mr-1 mb-1"
                                    alt="ellipsis-vertical"
                                  />
                                  {this.state.showHighRiskFlag ? 'Hide' : 'Show'} High Risk Options
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      </div>}
                    </div>
                    <div className="d-flex justify-content-between customization-heading-container flex-lg-row flex-column">
                      <p className='mb-0 d-md-flex family-details-form-top-text font-size-12 font-weight-light mb-2'>We’ve got all your details, let’s tailor-make a solution for you and your family! Psst: you can tweak it to suit you better.</p>
                      {showPasa &&
                        <div className="d-flex  mr-3 justify-content-end">
                          <p className="mr-2 border mb-0">Non-Pasa</p>
                          <ToggleButton
                            isChecked={this.state.isPasaProduct}
                            ontoggle={this.setIsPasaProduct.bind()}
                          />
                          <p className="ml-2 border mb-0">Pasa</p>
                        </div>
                      }

                    </div>
                    {(maxUpsellValue && showPasa) &&
                      <p className="mb-0 text-danger">Max upsell value is {global.toINR(maxUpsellValue)}</p>
                    }

                    {showSelectAtLeastOneNeedErrorMsg && <p className='mb-0 d-md-flex text-danger font-size-12 font-weight-light mb-2 font-red'>Please select atleast one need</p>}
                  </div>
                </div>
                {product_list_data.map((product_details, index) => {
                  return <NeedCard title={product_details.need_title} key={index} orderNumber={index + 1} cardKey={product_details.need_unique_name} data={product_details.data} />;
                })}

                <AddInsuredModalComponent
                  formController={this.state.familydetailsController}
                  show={OptimizationStore.isAddInsuredModalOpen}
                  onAddMember={this.onAddFamilyMember}
                  onAddInsured={() => { }}
                  onHide={this.addInsuredOnHide}
                />

                {validateCustomertype.includes(AuthStore.journeyTypeName) &&
                  <AddMemberCardModal
                    formController={this.state.familydetailsController}
                    familymemberList={familyDataList}
                    show={this.state.showFamilyMemberModal}
                    onAddMember={() => this.addFamilyMember(this.state.familydetailsController, this.hideFamilymemberModal)}
                    onHide={this.hideFamilymemberModal}
                  />
                }
                {!validateCustomertype.includes(AuthStore.journeyTypeName) &&
                  <AddEmployeeCardModal
                    formController={this.state.familydetailsController}
                    EmployeeList={familyDataList}
                    show={this.state.showFamilyMemberModal}
                    onAddMember={() => this.addFamilyMember(this.state.familydetailsController, this.hideFamilymemberModal)}
                    onHide={this.hideFamilymemberModal}

                  />
                }
                <ValidationErrorMessageShowModal />
                <ValidationMsgForRecalculate />
              </Container>
            )}
          </div>

          <CustomerCommunicationDetailModal {...this.props} />
        </>

      );
    }
  }
);

export default Optimization;
